import Route from "@ember/routing/route"
import { inject as service } from "@ember/service"

export default class ShowRoute extends Route {
  @service("ember-store")
  store
  // queryParams: {courseIds: {refreshModel: false}},
  // watchQueryParam: Ember.observer('courseIds', function(){
  //   console.log('qp', get(this, 'courseIds'))
  // })
}
